import { useState } from 'react';
import { useIntl } from 'react-intl';

import { IApplicationFormatted } from '../../../types';
import { pencilEdit } from '@developer/svg';
import { getAppStatusIconByStatus } from '@developer/portal/utils';
import { Icon } from '@developer/components';
import { AddEditApplicationModal } from '@developer/features';

import classes from './app-status.module.scss';
import { INREVIEWSTATUS,READYTOPUBLISHSTATUS} from '../../../constant';

type AppStatusProps = {
  application: IApplicationFormatted;
  setApplication: (data: IApplicationFormatted) => void;
};

export const AppStatus = ({ application, setApplication }: AppStatusProps) => {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const {
    status,
    name = '',
    created_at = '',
    application_types = [],
    categories = [],
    products = [],
    short_description,
    intendedPurposes = [],
    intendedUsers = []
  } = application;

  const hasApplication = !!Object.keys(application).length;
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const formatDate = (date: string) => {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return '';
    return dateObj.toLocaleDateString('en');
  };

  const formatApplicationStatus = (status:any) => {
    return status===READYTOPUBLISHSTATUS?INREVIEWSTATUS:status;
    };

  return (
    <div className={classes.wrapper}>
      {hasApplication && (
        <>
          <div className={classes.header}>
            <h3 className={classes.title}>{name}</h3>

            <div className={classes.header_icons}>
              <img src={pencilEdit} alt={''} onClick={openModal} />
            </div>
          </div>
          <div className={classes.app_data}>
            <div className={classes.app_data_column}>
              <h4 className={classes.app_data_column_heading}>
                {formatMessage({
                  id: 'app_status_current_status',
                })}
              </h4>
              <div className={classes.data}>
                <img src={getAppStatusIconByStatus(status)} alt="" />
                <span>{formatApplicationStatus(status)}</span>
              </div>
            </div>
            <div className={classes.app_data_column}>
              <h4 className={classes.app_data_column_heading}>
                {formatMessage({
                  id: 'app_status_modified',
                })}
              </h4>
              <div className={classes.data}>
                <Icon variant="application-status-date" height={16} width={17} />
                <span>{formatDate(created_at)}</span>
              </div>
            </div>

            {application_types[0]?.name && (
              <div className={classes.data}>
                <Icon
                  variant="application-status-type"
                  height={16}
                  width={17}
                />
                <span>{application_types[0]?.name}</span>
              </div>
            )}
            <div className={classes.app_data_column}>
              <h4 className={classes.app_data_column_heading}>
                {formatMessage({
                  id: 'app_status_categories',
                })}
              </h4>
              {categories.map((category) => (  
                <div className={classes.data}  key={category.id}>
                  <Icon
                    variant="application-status-category"
                    height={16}
                    width={17}
                  />
                  <span>{category?.name}</span>
                </div>
              ))}
            </div>
            <div className={classes.app_data_column}>
              <h4 className={classes.app_data_column_heading}>
                {formatMessage({
                  id: 'app_status_products',
                })}
              </h4>
              {products.map((product) => (
                <div className={classes.data}  key={product.id}>
                  <Icon
                    variant="application-status-solution"
                    height={16}
                    width={17}
                  />
                  <span>{product?.name}</span>
                </div>
              ))}
            </div>
            <div className={classes.app_data_column}>
              <h4 className={classes.app_data_column_heading}>
                {formatMessage({
                  id: 'app_status_purposes',
                })}
              </h4>
              {intendedPurposes.map((purpose) => (
                <div className={classes.data}  key={purpose.id}>
                  <Icon
                    variant="application-status-intended-purposes"
                    height={16}
                    width={17}
                  />
                  <span>{purpose?.name}</span>
                </div>
              ))}
            </div>
            <div className={classes.app_data_column}>
              <h4 className={classes.app_data_column_heading}>
                {formatMessage({
                  id: 'app_status_users',
                })}
              </h4>
              {intendedUsers.map((user) => (
                <div className={classes.data}  key={user.id}>
                  <Icon
                    variant="application-status-intended-users"
                    height={16}
                    width={17}
                  />
                  <span>{user?.name}</span>
                </div>
              ))}
            </div>
          </div>
          <p className={classes.description}>{short_description}</p>
          <AddEditApplicationModal
            isUpdate
            setApplication={setApplication}
            isOpen={isOpen}
            onReject={closeModal}
            application={application}
          />
        </>
      )}
    </div>
  );
};
